import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Icon from '../lib/img/my_location.svg';
import { getMap } from '../lib/mapService';
import setNewLocation from '../store/actions/setNewLocation';

const Button = styled.button`
  background-color: transparent;
  background-image: url(${Icon});
  background-repeat: no-repeat;
  background-position: center;
  width: 34px;
  height: 34px;
  display: block;
  pointer-events: all;
  border: none;
  padding: 0;
  opacity: 0.8;
  position: absolute;
  top: 50%;
  right: 0;
  margin: -17px 0 0 0;

  &:hover {
      opacity: 1;
  }

  &:active {
      opacity: 0.6;
  }
`;

const getUserLocation = async () => new Promise((resolve, reject) => {
  if ('geolocation' in navigator) {
    navigator.geolocation.getCurrentPosition(resolve, reject);
  } else {
    reject(Error('Client does not support Geolocation'));
  }
}).then((position) => ({
  lat: position.coords.latitude,
  lng: position.coords.longitude,
}));

/**
 * Locate myself feature.
 */
class MyLocation extends PureComponent {
  static propTypes = {
    updateLocation: PropTypes.func.isRequired,
  };

  /**
   * @param {!props} props component properties
   */
  constructor(props) {
    super(props);
    this.findUserLocation = this.findUserLocation.bind(this);
  }

  /**
   * Locates the current user and dispatches the new values.
   */
  findUserLocation() {
    const { updateLocation } = this.props;

    getUserLocation().then((coord) => {
      // map center is not set based on the coordinate param to prevent
      // excessive re-renders
      getMap().setCenter(coord);
      updateLocation(coord, 11);
    }).catch((error) => {
    });
  }

  /**
  * React Lifecycle method.
  * @return {jsx} jsx representation of the component.
   */
  render() {
    return (
      <Button
        id="My location"
        aria-label="Go to my location"
        title="Go to my location"
        onClick={this.findUserLocation}
      />
    );
  }
}

export default connect(
    null,

    (dispatch) => ({
      updateLocation: (coordinate, zoom) => {
        dispatch(setNewLocation(coordinate, zoom));
      },
    }),
)(MyLocation);
